import { CustomPlayersLocalPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const CustomPlayersLocalPersistenceProvider =
  createStaticContextProvider(
    CustomPlayersLocalPersistenceContext,
    lazyValue(() =>
      import("./custom-players-local-persistence").then(
        (module) => module.customPlayersLocalPersistence,
      ),
    ),
  );
